var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { compose } from 'redux';
import { Button, Modal } from '@appspotr/ui-kit';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons';
import { CardNumberElement, useElements, useStripe, } from '@stripe/react-stripe-js';
import { usePrevious } from 'utils/hooks/values';
import injectReducer from 'utils/injectReducer';
import { useThunkTrigger } from 'utils/hooks/services';
import { useErrorToast, useSuccessToast } from 'utils/hooks/toast';
import * as rootActions from 'containers/Root/actions';
import { PaymentMethod } from 'containers/PartnerOrganizations/models';
import toast from 'components/Toast';
import { CardDetailsEntry } from 'components/CardDetailsEntry';
import { ModalContentWrapper, ModalText, Spacer } from 'components/base';
import { CardStatus } from './models';
import reducer from './reducer';
import * as actions from './actions';
import { makeSelectPaymentModal } from './selectors';
import { BigLabel, BodyWrapper, ContentOnlyWrapper, ModalElementWrapper, ModalFooterWrapper, SmallLabel, ContentOnlyMargin, } from './styles';
import { checkOrgStatusSummery } from '../../store/orgStatusSummery/actions';
import { selectStatusLoading, selectPaymentSummery, } from '../../store/orgStatusSummery/selectors';
import { selectPayementDetails } from 'containers/Root/selectors';
import { resolveCardAssignStatus, selectCardCheckSource, selectCardCheckLoading, } from './helpers';
var PaymentEntry = function (_a) {
    var isOpen = _a.isOpen, closeModal = _a.closeModal, _b = _a.organization, organization = _b === void 0 ? {} : _b, country = _a.country, selectedBundle = _a.selectedBundle, modalMode = _a.modalMode, type = _a.type, contentOnly = _a.contentOnly, contentOnlyConfig = _a.contentOnlyConfig, onSignupSuccess = _a.onSignupSuccess, purchasedDevPlan = _a.purchasedDevPlan, on3DSSuccess = _a.on3DSSuccess, paymentModalState = _a.paymentModalState, onCardAssignStatusChanged = _a.onCardAssignStatusChanged, onDisableActionButton = _a.onDisableActionButton, setLoading = _a.setLoading, back = _a.back, moveStep = _a.moveStep, billingPage = _a.billingPage;
    var paymentDetails = useSelector(selectPayementDetails);
    var customerCardLoading = useSelector(selectStatusLoading);
    var paymentSettings = useSelector(makeSelectPaymentModal());
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var _d = useState(''), assignedPaymentMethodId = _d[0], setPaymentMethodId = _d[1];
    var _e = useState(''), cardHolderName = _e[0], _setCardHolderName = _e[1];
    var setCardHolderName = function (e) {
        var target = e.target;
        _setCardHolderName(target.value);
        if (onDisableActionButton) {
            if (target.value) {
                onDisableActionButton(false);
            }
            else {
                onDisableActionButton(true);
            }
        }
    };
    var customerCard = paymentDetails.customerCard;
    var orgPaymentSummary = useSelector(selectPaymentSummery);
    var cardCheckSource = selectCardCheckSource(type, customerCard, orgPaymentSummary === null || orgPaymentSummary === void 0 ? void 0 : orgPaymentSummary.card_payment_method);
    var cardCheckLoading = selectCardCheckLoading(type, paymentDetails.customerCardLoading, customerCardLoading);
    var cardAssignLoading = paymentSettings.cardAssignLoading, getSecretLoading = paymentSettings.getSecretLoading, clientSecret = paymentSettings.clientSecret, inputMode = paymentSettings.inputMode, confirmPaymentError = paymentSettings.confirmPaymentError, confirmPaymentLoading = paymentSettings.confirmPaymentLoading, confirmPaymentStatus = paymentSettings.confirmPaymentStatus, purchaseBundleLoading = paymentSettings.purchaseBundleLoading, purchaseBundleError = paymentSettings.purchaseBundleError, cardAssignError = paymentSettings.cardAssignError, cardAssigned = paymentSettings.cardAssigned, cardState = paymentSettings.cardState;
    var dispatch = useDispatch();
    var stripe = useStripe();
    var elements = useElements();
    var previousClientSecret = usePrevious(clientSecret);
    var prevCMSActivateClientSecret = usePrevious(purchasedDevPlan === null || purchasedDevPlan === void 0 ? void 0 : purchasedDevPlan.client_secret);
    var dispatchResetPaymentState = function () {
        return dispatch(actions.resetPaymentState());
    };
    var dispatchCheckCustomerCard = function (orgId) {
        return dispatch(checkOrgStatusSummery(orgId));
    };
    var dispatchCheckCustomerCardSignup = function () {
        return dispatch(rootActions.checkCustomerCardSignup());
    };
    var dispatchPurchaseBundlesAvailableByOrg = function (orgId, bundleId) {
        dispatch(actions.purchaseBundlesAvailableByOrg(orgId, bundleId));
    };
    var dispatchResetClientSecret = useCallback(function () { return dispatch(actions.resetClientSecret()); }, [dispatch]);
    var dispatchSetConfirmPaymentStatus = useCallback(function (status, error) {
        return dispatch(actions.setConfirmPaymentStatus(status, error));
    }, [dispatch]);
    var dispatchAssignPaymentMethodToOrganization = useCallback(function (org, paymentMethodId) {
        return dispatch(actions.assignPaymentMethodToOrganization(org, paymentMethodId));
    }, [dispatch]);
    var dispatchAssignPaymentMethodToSignup = useCallback(function (paymentMethodId, country) {
        return dispatch(actions.assignPaymentMethodToSignup(paymentMethodId, country));
    }, [dispatch]);
    var dispatchChangeInputMode = useCallback(function (mode) { return dispatch(actions.changeInputMode(mode)); }, [dispatch]);
    useSuccessToast('Card details has been saved successfully', [cardAssigned], (function () {
        dispatchResetPaymentState();
        if (!contentOnly)
            closeModal();
    }));
    useSuccessToast('Successfully bundle purchased', [!purchaseBundleLoading, !purchaseBundleError], (function () {
        dispatchResetPaymentState();
        if (!contentOnly)
            closeModal();
    }));
    useErrorToast('An error occurred while saving card details.', [
        !cardAssignLoading,
        cardAssignError === null || cardAssignError === void 0 ? void 0 : cardAssignError.code,
    ]);
    useErrorToast('An error occurred while purchasing bundle.', [
        !purchaseBundleLoading,
        purchaseBundleError,
    ]);
    useThunkTrigger(function () {
        if (type === 'SIGNUP') {
            dispatchCheckCustomerCardSignup();
        }
        else if (organization === null || organization === void 0 ? void 0 : organization.id) {
            dispatchCheckCustomerCard(organization.id);
        }
    }, isOpen &&
        (organization === null || organization === void 0 ? void 0 : organization.default_payment_method) === PaymentMethod.Card &&
        !(cardAssignError === null || cardAssignError === void 0 ? void 0 : cardAssignError.message), [cardAssignError === null || cardAssignError === void 0 ? void 0 : cardAssignError.message, organization === null || organization === void 0 ? void 0 : organization.default_payment_method]);
    useEffect(function () {
        var _a;
        if (paymentModalState &&
            paymentModalState === 'CONFIRMED' &&
            (purchasedDevPlan === null || purchasedDevPlan === void 0 ? void 0 : purchasedDevPlan.client_secret) &&
            prevCMSActivateClientSecret !== (purchasedDevPlan === null || purchasedDevPlan === void 0 ? void 0 : purchasedDevPlan.client_secret) &&
            stripe &&
            elements) {
            setIsLoading(true);
            if ((_a = purchasedDevPlan === null || purchasedDevPlan === void 0 ? void 0 : purchasedDevPlan.client_secret) === null || _a === void 0 ? void 0 : _a.startsWith('pi_')) {
                stripe
                    .confirmCardPayment(purchasedDevPlan === null || purchasedDevPlan === void 0 ? void 0 : purchasedDevPlan.client_secret)
                    .then(function (result) {
                    var _a;
                    setIsLoading(false);
                    if (((_a = result === null || result === void 0 ? void 0 : result.paymentIntent) === null || _a === void 0 ? void 0 : _a.status) === 'succeeded') {
                        on3DSSuccess();
                    }
                });
            }
            else {
                stripe
                    .confirmCardSetup(purchasedDevPlan === null || purchasedDevPlan === void 0 ? void 0 : purchasedDevPlan.client_secret)
                    .then(function (result) {
                    var _a;
                    setIsLoading(false);
                    if (((_a = result === null || result === void 0 ? void 0 : result.setupIntent) === null || _a === void 0 ? void 0 : _a.status) === 'succeeded') {
                        on3DSSuccess();
                    }
                });
            }
        }
    }, [
        elements,
        on3DSSuccess,
        paymentModalState,
        prevCMSActivateClientSecret,
        purchasedDevPlan === null || purchasedDevPlan === void 0 ? void 0 : purchasedDevPlan.client_secret,
        stripe,
    ]);
    useEffect(function () {
        if (cardAssignError &&
            (cardAssignError === null || cardAssignError === void 0 ? void 0 : cardAssignError.code) &&
            paymentModalState === 'ASSIGN_CARD') {
            onCardAssignStatusChanged('ASSIGN_CARD_FAILED');
        }
    }, [cardAssignError, onCardAssignStatusChanged, paymentModalState]);
    useEffect(function () {
        if (!onCardAssignStatusChanged)
            return;
        var nextStatus = resolveCardAssignStatus({
            paymentModalState: paymentModalState,
            defaultPaymentMethod: organization.default_payment_method,
            cardPaymentMethod: cardCheckSource,
            cardAssigned: cardAssigned,
            cardCheckLoading: cardCheckLoading,
        });
        if (nextStatus) {
            onCardAssignStatusChanged(nextStatus);
        }
    }, [
        organization.default_payment_method,
        cardCheckSource,
        cardAssigned,
        cardCheckLoading,
        onCardAssignStatusChanged,
        paymentModalState,
    ]);
    useEffect(function () {
        if (!previousClientSecret && clientSecret !== '' && stripe && elements) {
            if (type === 'SIGNUP') {
                if (clientSecret === null || clientSecret === void 0 ? void 0 : clientSecret.startsWith('pi_')) {
                    setIsLoading(true);
                    stripe.confirmCardPayment(clientSecret).then(function (result) {
                        setIsLoading(false);
                        if (result === null || result === void 0 ? void 0 : result.error) {
                            dispatchResetClientSecret();
                        }
                        else {
                            onSignupSuccess();
                        }
                    });
                }
                else {
                    setIsLoading(true);
                    stripe
                        .confirmCardSetup(clientSecret, {
                        payment_method: assignedPaymentMethodId,
                    })
                        .then(function (result) {
                        setIsLoading(false);
                        if (result === null || result === void 0 ? void 0 : result.error) {
                            dispatchResetClientSecret();
                        }
                        else {
                            onSignupSuccess();
                        }
                    });
                }
            }
            else {
                if (clientSecret &&
                    stripe &&
                    elements &&
                    !confirmPaymentLoading &&
                    !confirmPaymentStatus &&
                    confirmPaymentError === '') {
                    dispatchSetConfirmPaymentStatus('loading', '');
                    setIsLoading(true);
                    if (cardState === 'CARD_SAVED' && assignedPaymentMethodId) {
                        if (clientSecret.startsWith('pi_')) {
                            stripe.confirmCardPayment(clientSecret).then(function (result) {
                                var _a;
                                setIsLoading(false);
                                if (result === null || result === void 0 ? void 0 : result.error) {
                                    dispatchSetConfirmPaymentStatus('error', ((_a = result === null || result === void 0 ? void 0 : result.error) === null || _a === void 0 ? void 0 : _a.message) || '');
                                    dispatchResetClientSecret();
                                }
                                else {
                                    dispatchSetConfirmPaymentStatus('success', '');
                                    onSignupSuccess === null || onSignupSuccess === void 0 ? void 0 : onSignupSuccess();
                                }
                            });
                        }
                        else {
                            stripe
                                .confirmCardSetup(clientSecret, {
                                payment_method: assignedPaymentMethodId,
                            })
                                .then(function (result) {
                                var _a;
                                setIsLoading(false);
                                if (result.error) {
                                    dispatchSetConfirmPaymentStatus('error', ((_a = result === null || result === void 0 ? void 0 : result.error) === null || _a === void 0 ? void 0 : _a.message) || '');
                                }
                                else {
                                    if (result.setupIntent.status === 'succeeded') {
                                        dispatchSetConfirmPaymentStatus('success', '');
                                    }
                                }
                                toast.success('Card has been activated successfully');
                                dispatchResetClientSecret();
                                if (!contentOnly)
                                    closeModal === null || closeModal === void 0 ? void 0 : closeModal();
                            });
                        }
                    }
                    else {
                        if (clientSecret.startsWith('pi_')) {
                            stripe.confirmCardPayment(clientSecret).then(function (result) {
                                var _a;
                                setIsLoading(false);
                                if (result === null || result === void 0 ? void 0 : result.error) {
                                    dispatchSetConfirmPaymentStatus('error', ((_a = result === null || result === void 0 ? void 0 : result.error) === null || _a === void 0 ? void 0 : _a.message) || '');
                                    dispatchResetClientSecret();
                                }
                                else {
                                    dispatchSetConfirmPaymentStatus('success', '');
                                    onSignupSuccess === null || onSignupSuccess === void 0 ? void 0 : onSignupSuccess();
                                }
                            });
                        }
                        else {
                            stripe
                                .confirmCardSetup(clientSecret, {
                                payment_method: assignedPaymentMethodId,
                            })
                                .then(function (result) {
                                setIsLoading(false);
                                if (result === null || result === void 0 ? void 0 : result.error) {
                                    dispatchResetClientSecret();
                                }
                                else {
                                    onSignupSuccess === null || onSignupSuccess === void 0 ? void 0 : onSignupSuccess();
                                }
                            });
                        }
                    }
                }
            }
        }
    }, [
        previousClientSecret,
        clientSecret,
        stripe,
        elements,
        type,
        dispatchResetClientSecret,
        onSignupSuccess,
        assignedPaymentMethodId,
        confirmPaymentLoading,
        confirmPaymentStatus,
        confirmPaymentError,
        dispatchSetConfirmPaymentStatus,
        cardState,
        closeModal,
        contentOnly,
    ]);
    var assignCard = useCallback(function (org, paymentMethodId, country) {
        if (type === 'SIGNUP') {
            dispatchAssignPaymentMethodToSignup(paymentMethodId, country);
        }
        else {
            dispatchAssignPaymentMethodToOrganization(org, paymentMethodId);
        }
    }, [
        type,
        dispatchAssignPaymentMethodToSignup,
        dispatchAssignPaymentMethodToOrganization,
    ]);
    var createPaymentMethodAndAssign = useCallback(function () {
        if (!stripe || !elements)
            return;
        var cardElement = elements.getElement(CardNumberElement);
        if (!cardElement) {
            toast.error('Stripe Payment not available, please try again later');
            if (setLoading)
                setLoading(false);
            setTimeout(function () {
                moveStep(2);
                back();
            }, 3000);
            return;
        }
        stripe
            .createPaymentMethod({
            type: 'card',
            card: cardElement,
            billing_details: {
                name: cardHolderName,
            },
        })
            .then(function (result) {
            var _a;
            if (result.error) {
                toast.error(result.error.message);
                return;
            }
            dispatchChangeInputMode('');
            setPaymentMethodId((_a = result === null || result === void 0 ? void 0 : result.paymentMethod) === null || _a === void 0 ? void 0 : _a.id);
            assignCard(organization.id, result.paymentMethod.id, country);
        });
    }, [
        stripe,
        elements,
        cardHolderName,
        dispatchChangeInputMode,
        assignCard,
        organization.id,
        country,
        setLoading,
        moveStep,
        back,
    ]);
    var createPaymentMethodAndAssignRef = useRef(createPaymentMethodAndAssign);
    useEffect(function () {
        createPaymentMethodAndAssignRef.current = createPaymentMethodAndAssign;
    });
    useEffect(function () {
        if (paymentModalState === 'ASSIGN_CARD') {
            createPaymentMethodAndAssignRef.current();
        }
    }, [paymentModalState]);
    var getLoadingState = function () { return ({
        isLoading: confirmPaymentLoading ||
            customerCardLoading ||
            cardAssignLoading ||
            purchaseBundleLoading ||
            getSecretLoading ||
            isLoading,
    }); };
    var getFooterContent = function (cardStatus) {
        if (inputMode === 'update' ||
            [CardStatus.Expired, CardStatus.NoExist].includes(cardStatus) ||
            type === 'SIGNUP' ||
            billingPage) {
            return (_jsxs(ContentOnlyWrapper, { children: [_jsx(Button, __assign({ onClick: function () { return closeModal(); }, type: "outline" }, { children: "Cancel" })), _jsx(Spacer, {}), _jsx(Button, __assign({ disabled: getLoadingState().isLoading || cardHolderName === '', onClick: function () { return createPaymentMethodAndAssign(); }, iconRight: cardAssignLoading ? faSpinner : undefined, iconRightSpin: cardAssignLoading }, { children: "Save Card" }))] }));
        }
        if (modalMode === 'payment' &&
            (organization.default_payment_method === PaymentMethod.Invoice ||
                (organization.default_payment_method === PaymentMethod.Card &&
                    cardStatus === CardStatus.Valid))) {
            return (_jsx(Button, __assign({ disabled: getLoadingState().isLoading, onClick: function () { return handlePurchase(); } }, { children: purchaseBundleLoading ? 'Purchasing..' : 'Pay' })));
        }
        return null;
    };
    var handlePurchase = function () {
        if (organization.default_payment_method === PaymentMethod.Card) {
            dispatchPurchaseBundlesAvailableByOrg(organization.id, selectedBundle.id);
        }
        else {
            if (window.confirm('Are you sure you want to proceed with this purchase?'))
                dispatchPurchaseBundlesAvailableByOrg(organization.id, selectedBundle.id);
        }
    };
    var priceBuilder = function (amount, currency) {
        if (amount === void 0) { amount = '0'; }
        if (currency === void 0) { currency = 'sek'; }
        var formatter = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: currency,
        });
        var priceString = formatter.format(parseFloat(amount) / 100).toString();
        priceString = priceString.replace(/[^0-9.,]+/, '');
        return priceString.trim();
    };
    var getBody = function () {
        var _a;
        if (getLoadingState())
            return null;
        if (confirmPaymentStatus && type !== 'SIGNUP' && type !== 'SET_CARD')
            return (_jsxs(BodyWrapper, __assign({ center: true }, { children: [_jsx(BigLabel, { children: "Purchase successful." }), _jsx(SmallLabel, { children: "You have bought ".concat(selectedBundle === null || selectedBundle === void 0 ? void 0 : selectedBundle.name, ".") })] })));
        if (selectedBundle &&
            (organization === null || organization === void 0 ? void 0 : organization.default_payment_method) === (PaymentMethod === null || PaymentMethod === void 0 ? void 0 : PaymentMethod.Invoice))
            return (_jsxs(BodyWrapper, { children: [_jsx(SmallLabel, { children: selectedBundle === null || selectedBundle === void 0 ? void 0 : selectedBundle.name }), _jsx(SmallLabel, { children: organization === null || organization === void 0 ? void 0 : organization.name }), _jsxs(SmallLabel, { children: [priceBuilder(selectedBundle === null || selectedBundle === void 0 ? void 0 : selectedBundle.amount, selectedBundle === null || selectedBundle === void 0 ? void 0 : selectedBundle.currency), (_a = selectedBundle === null || selectedBundle === void 0 ? void 0 : selectedBundle.currency) === null || _a === void 0 ? void 0 : _a.toUpperCase()] })] }));
        return null;
    };
    var renderModalFooter = function () { return (_jsx(ModalFooterWrapper, { children: _jsx(Button, __assign({ disabled: getLoadingState().isLoading || cardHolderName === '', onClick: function () { return createPaymentMethodAndAssign(); }, iconRight: cardAssignLoading ? faSpinner : undefined, iconRightSpin: cardAssignLoading }, { children: "Save Card" })) })); };
    if (!organization)
        return null;
    if (contentOnly || billingPage)
        return (_jsxs(_Fragment, { children: [_jsx(ContentOnlyMargin, { children: _jsx(CardDetailsEntry, { onNameChange: setCardHolderName, billingPage: billingPage }) }), (contentOnlyConfig === null || contentOnlyConfig === void 0 ? void 0 : contentOnlyConfig.body) && getBody(), (contentOnlyConfig === null || contentOnlyConfig === void 0 ? void 0 : contentOnlyConfig.footer) &&
                    getFooterContent(customerCard === null || customerCard === void 0 ? void 0 : customerCard.card_valid)] }));
    return (_jsx(Modal, __assign({ isOpen: isOpen, closeModal: closeModal, title: "Add Card Details", footer: renderModalFooter(), size: "md" }, { children: _jsxs(ModalContentWrapper, __assign({ space: true, centered: true }, { children: [_jsx(ModalText, __assign({ center: true }, { children: "The card you provide will be saved and used for all future payments." })), _jsx(ModalElementWrapper, { children: _jsx(CardDetailsEntry, { onNameChange: setCardHolderName, billingPage: billingPage }) })] })) })));
};
var withReducer = injectReducer({ key: 'paymentSettings', reducer: reducer });
export default compose(withReducer)(PaymentEntry);
